// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pz-1";
export var messageSideRight = "_pz-2";
export var subscribeToBackInStockBubbleContainer = "_pz-0";